import React from "react";
import { Col } from "react-bootstrap";
import Form from "react-bootstrap/Form";


const FormInput = ({
    label,
    type,
    placeholder,
    value,
    name,
    onChange,
    onFocus,
    controlId,
    md,
    className,
    grpClassname,
    maxLength,
    multiple,
    disabled,
    inputIcons,
    readOnly
}) => {
    return (
        <Form.Group as={Col} className={`position-relative form-grp ${grpClassname}`} controlId={controlId} md={md}>
            <fieldset className="frm-fieldset">
                <legend className="frm-legend"><Form.Label>{label}</Form.Label></legend>
                {type === "textarea" ? (
                    <Form.Control
                        as="textarea"
                        rows={4}
                        placeholder={placeholder}
                        value={value || ""}
                        name={name}
                        onChange={onChange}
                        onFocus={onFocus}
                        className={className}
                        disabled={disabled}
                        readOnly={readOnly}
                    />
                ) : (
                    <>
                        <Form.Control
                            type={type}
                            placeholder={placeholder}
                            value={value || ""}
                            name={name}
                            onChange={onChange}
                            onFocus={onFocus}
                            className={className}
                            maxLength={maxLength}
                            multiple={multiple}
                            disabled={disabled}
                        />
                        {inputIcons}
                    </>

                )}
            </fieldset>
        </Form.Group>
    );
};

export default FormInput;
